var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLessonIcon04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0996 3.5H13.5996C13.9974 3.5 14.379 3.65804 14.6603 3.93934C14.9416 4.22064 15.0996 4.60218 15.0996 5V15.5C15.0996 15.8978 14.9416 16.2794 14.6603 16.5607C14.379 16.842 13.9974 17 13.5996 17H4.59961C4.20178 17 3.82025 16.842 3.53895 16.5607C3.25764 16.2794 3.09961 15.8978 3.09961 15.5V5C3.09961 4.60218 3.25764 4.22064 3.53895 3.93934C3.82025 3.65804 4.20178 3.5 4.59961 3.5H6.09961",
    stroke: "#2C323F",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3496 2H6.84961C6.4354 2 6.09961 2.33579 6.09961 2.75V4.25C6.09961 4.66421 6.4354 5 6.84961 5H11.3496C11.7638 5 12.0996 4.66421 12.0996 4.25V2.75C12.0996 2.33579 11.7638 2 11.3496 2Z",
    stroke: "#2C323F",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessonIcon04);
export default __webpack_public_path__ + "static/media/lesson-icon-04.c72d07256d8832fe0e410b74256cfe39.svg";
export { ForwardRef as ReactComponent };